import React from 'react';
import { BoxIcon } from 'lucide-react';
interface GameButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary' | 'danger';
  icon?: BoxIcon;
}
export function GameButton({
  children,
  variant = 'primary',
  icon: Icon,
  className = '',
  ...props
}: GameButtonProps) {
  const baseStyles = 'relative px-6 py-3 font-bold uppercase tracking-widest transition-transform active:translate-y-1 active:translate-x-1 border-2 border-black text-sm md:text-base flex items-center justify-center gap-2';
  const variants = {
    primary: 'bg-red-600 text-white shadow-[4px_4px_0px_0px_rgba(0,0,0,1)] hover:bg-red-700',
    secondary: 'bg-white text-black shadow-[4px_4px_0px_0px_rgba(0,0,0,1)] hover:bg-gray-50',
    danger: 'bg-black text-white shadow-[4px_4px_0px_0px_rgba(255,0,0,1)] hover:bg-gray-900'
  };
  return <button className={`${baseStyles} ${variants[variant]} ${className}`} {...props} data-id="element-6">
      {Icon && <Icon className="w-5 h-5" data-id="element-7" />}
      {children}
    </button>;
}